import React, { useState, useEffect } from 'react';
import { MenuItem, TextField } from '@mui/material';
import { URLS } from '../../helpers/URLS';
import { matchesSearch } from '../../helpers/search';
import useAxios from '../../helpers/Hooks/useAxios';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import EmpDetails from './EmpDetails';
import PaginationGlobal from '../TablePagination.js/PaginationGlobal';
import "../../components/AdminHeader/AdminHeader.scss"
import "../../assets/scss/tables.scss";
import { downloadLink } from '../../helpers/constFIles';

/* Everything on a row is searchable, so the box matches what the user can
   actually see in the table rather than skills alone. `skill` and `project`
   are the comma-joined strings built when the list loads. */
const SEARCH_FIELDS = [
  'employeeCode', 'employeeName', 'emailID',
  'designation', 'department', 'experience',
  'project', 'skill',
];

const initials = (name) => {
  if (!name) return "?";
  const parts = String(name).trim().split(/\s+/);
  return ((parts[0] ? parts[0][0] : "") +
    (parts.length > 1 ? parts[parts.length - 1][0] : "")).toUpperCase();
};

const SearchSkills = () => {

  const [search, setSearch] = useState('');

  const { fetchData } = useAxios();

  const [empSkillData, setEmpSkillData] = useState([]);

  const [searchResult, setSearchResult] = useState([]);

  const [currentEmp, setCurrentEmp] = useState([]);

  const [isModal, setIsModal] = useState(false);

  const [filterQuery, setFilterQuery] = useState('All');

  const arrFilter = ['All', 'In-Project', 'Pool', 'Training'];

  const [pageNumber, setPageNumber] = useState(1);

  useEffect(() => {
    getEmpWithSkills();
  }, [])

  const getEmpWithSkills = async () => {
    const resp = await fetchData({ url: URLS.getEmpWithSkills, method: 'get' });
    let employees = resp.data;
    employees.forEach(emp => {
      emp.skill = '';
      emp.project = '';
      emp.skills.forEach((skill, index) => {
        emp.skill += (emp.skills.length - 1 === index) ? skill.name : skill.name + ',';
      })
      emp.projects.forEach((proj, index) => {
        emp.project += (emp.projects.length - 1 === index) ? proj.project.projectName : proj.project.projectName + ',';
      })
    })
    setEmpSkillData(employees);
    setSearchResult(employees);
  }

  useEffect(() => {
    filter();
  }, [filterQuery, search])

  const filter = (e) => {
    let emps = empSkillData;
    setPageNumber(1);
    if (filterQuery === 'All') {
      setSearchResult(emps.filter(emp => matchesSearch(emp, search, SEARCH_FIELDS)))
    }
    else if (filterQuery === 'In-Project') {
      let filterResult = [];
      emps.filter(emp => matchesSearch(emp, search, SEARCH_FIELDS)).forEach((item) => {
        item.projects && item.projects.length > 0 &&
          item.projects.forEach((prj) => {
            if (prj.project.projectName.toLowerCase() !== 'pool') {
              if (prj.project.projectName.toLowerCase() !== 'training') {
                if (!(filterResult.find((x) => x._id === item._id))) {
                  filterResult.push(item);
                }
              }
            }
          })
      })
      setSearchResult(filterResult);
    } else if(filterQuery === "Pool"){
      if(search)
      {
        emps =  emps.filter(emp => matchesSearch(emp, search, SEARCH_FIELDS))
      }
      emps.forEach(x=>{
        console.log("KK",x.project)
      })
      const unAssigned = emps.filter(emp=>!emp.project)
      const list = emps.filter(emp=>emp.project?.toLowerCase().trim() === "ML-Administration".toLowerCase())
      setSearchResult([...list,...unAssigned])

    }
    else if (filterQuery !== 'All' || filterQuery !== 'In-Project') {
      let filterResult = [];
      emps.filter(emp => matchesSearch(emp, search, SEARCH_FIELDS)).forEach((item) => {
        item.projects && item.projects.length > 0 &&
          item.projects.forEach((prj) => {
            if (prj.project.projectName.toLowerCase() === filterQuery.toLowerCase()) {
              if (!(filterResult.find(x => x._id === item._id))) {
                filterResult.push(item);
              }
            }
          })
      })
      setSearchResult(filterResult);
    }
  }

  const hideModal = () => {
    setIsModal(!isModal);
  }

  const pull_data = (data) => {
    setPageNumber(data)
  }

  const [rowsPerPage, setRowsPerPage] = useState(15);

  return (
    <div className='wh-table'>
      <div className='wh-toolbar'>
        <h4 className='title'>Skill Search</h4>

        <div className='wh-toolbar-controls'>
          <TextField
            placeholder='Search name, code, email, skill…'
            size='small'
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className='wh-search-field'
            InputProps={{
              startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
              endAdornment: search
                ? <InputAdornment position="end">
                    <IconButton size='small' className='wh-search-clear'
                      aria-label='Clear search' onClick={() => setSearch('')}>
                      <CloseRoundedIcon fontSize='small' />
                    </IconButton>
                  </InputAdornment>
                : null,
            }}
          />

          <TextField select label='Project' size='small' id={'drpProject'}
            className='wh-filter-field'
            value={filterQuery}
            onChange={(e) => setFilterQuery(e.target.value)}>
            {arrFilter.map((item, index) =>
              <MenuItem key={index} value={item}>{item}</MenuItem>
            )}
          </TextField>
        </div>
      </div>
      <div className='bg-wht mt-3'>
        <div className='table-responsive tab-styles'>
          <table className='table'>
            <thead>
              <tr>
                <th>Employee ID</th>
                <th scope='col'>Employee Name</th>
                <th scope='col'>Experience</th>
                <th scope='col'>Project</th>
                <th scope='col'>Skills</th>
              </tr>
            </thead>
            <tbody>
              {searchResult && searchResult.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage).map((emp, index) =>
                <tr key={index}>
                  <td>{emp.employeeCode}</td>
                  <td>
                    <div className='wh-person'>
                      {emp.profilePic
                        ? <img className='wh-avatar wh-avatar-sm'
                            src={downloadLink + emp.profilePic}
                            alt=''
                            onError={(e) => { e.currentTarget.style.display = 'none'; }} />
                        : null}
                      <span className='wh-avatar wh-avatar-sm'>{initials(emp.employeeName)}</span>
                      <button type='button' className='wh-person-name wh-person-link'
                        title={`View ${emp.employeeName}`}
                        onClick={() => { setCurrentEmp(emp); setIsModal(true) }}>
                        {emp.employeeName}
                      </button>
                    </div>
                  </td>
                  <td className='text-nowrap'>{emp.experience ? emp.experience : '--'}</td>
                  <td> {emp.project ? emp.project : '--'}</td>
                  <td>
                    {emp.skills && emp.skills.length > 0
                      ? <div className='wh-pills'>
                          {emp.skills.map((item, i) => <span className='wh-pill' key={i}>{item.name}</span>)}
                        </div>
                      : '--'}
                  </td>
                </tr>
              )
              }
            </tbody>
          </table>
          {searchResult && searchResult.length > 0 ? <PaginationGlobal
            count={Math.ceil(searchResult.length / rowsPerPage)}
            pageNumber={pageNumber} func={pull_data}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={(size) => { setRowsPerPage(size); setPageNumber(1); }} /> : ''}
        </div>
      </div>
      <EmpDetails show={isModal} data={currentEmp} hide={hideModal} />
    </div>
  )
}

export default SearchSkills
